// import { GENERATE_URL } from "./helpers/request.js";

import Account from "./Account";
import Admin from "./Admin";
import Battery from "./Battery";
import CompressorBrands from "./CompressorBrands";
import Project from "./Project";
import BatteryFeatures from "./BatteryFeatures";
import FinPitches from "./FinPitches";
import Geometry from "./Geometry";
import Refrigerants from "./Refrigerants";
import Materials from "./Materials";
import Thicknesses from "./Thicknesses";
import BatteryPermissions from "./BatteryPermissions";
import CompressorBrandRefrigerants from "./CompressorBrandRefrigerants";
import CompressorRefrigerantModels from "./CompressorRefrigerantModels";
import ProjectPermissions from "./ProjectPermissions";
import MainProject from "./MainProject";
import Series from "./Series";
import Cycle from "./Cycle";
import CycleParameters from "./CycleParameters";
import CyclePermissions from "./CyclePermissions";
import AuthorityDepartmentUser from "./AuthorityDepartmentUser";
import DepartmentUser from "./DepartmentUser";
import Department from "./Department";
import ProjectFileLog from "./ProjectFileLog";
import CraneHVACC from "./CraneHVACC";
import HeatGain from "./HeatGain";
import ProjectTag from "./ProjectTag";
import ProjectMainProject from "./ProjectMainProject";
import Tks from "./Tks";
import AuxiliaryCoolingEquipment from "./AuxiliaryCoolingEquipment";
import ProjectAuxiliaryCoolingEquipment from "./ProjectAuxiliaryCoolingEquipment";
import TechinalDrawing from "./TechinalDrawing";
export default {
  Account,
  Admin,
  Battery,
  Project,
  BatteryFeatures,
  FinPitches,
  Geometry,
  Refrigerants,
  CompressorBrands,
  Materials,
  Thicknesses,
  BatteryPermissions,
  CompressorBrandRefrigerants,
  CompressorRefrigerantModels,
  ProjectPermissions,
  Cycle,
  MainProject,
  Series,
  CycleParameters,
  CyclePermissions,
  AuthorityDepartmentUser,
  DepartmentUser,
  Department,
  ProjectFileLog,
  CraneHVACC,
  HeatGain,
  ProjectTag,
  ProjectMainProject,
  Tks,
  AuxiliaryCoolingEquipment,
  ProjectAuxiliaryCoolingEquipment,
  TechinalDrawing,
};
